export class CustomRuleApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCustomRuleById({ id }) {
    return this.#http.get(`/customRule/${id}`);
  }

  async deleteCustomRule({ id }) {
    return this.#http.delete(`/customRule/${id}`);
  }

  async getCustomRule() {
    return this.#http.get('/customRule');
  }

  async createCustomRule(body) {
    return this.#http.post('/customRule', body);
  }

  async editCustomRule(body) {
    return this.#http.put('/customRule', body);
  }

  async createCustomRuleClone(body) {
    return this.#http.post('/customRule/clone', body);
  }

  async createCustomRuleCloneHierarchically(body) {
    return this.#http.post('/customRule/clone/hierarchically', body);
  }
}
